import Dialog, {
  DialogHeader,
  DialogContent,
  DialogFooter,
} from '@guestyci/foundation/Dialog';
import { Row } from '@guestyci/foundation/Layout';
import TextField from '@guestyci/foundation/TextField';
import FlatButton from '@guestyci/foundation/FlatButton';
import RaisedButton from '@guestyci/foundation/RaisedButton';
import t from '@guestyci/localize/t.macro';
import createStyles from '@guestyci/foundation/createStyles';
import history from '@guestyci/history';

import { useAppDispatch, useAppSelector } from 'store';
import { dirtyAnswerAction } from 'ui/ui.actions';

const useStyles = createStyles(({ breakpoints: { down } }) => ({
  root: {
    maxWidth: '500px',
    [down('sm')]: {
      minWidth: 'unset',
    },
  },
}));

const DirtyWarningDialog = () => {
  const classes = useStyles();

  const dispatch = useAppDispatch();
  const navigateTo = useAppSelector((state) => state.ui.navigateTo);

  if (!navigateTo) {
    return null;
  }

  const onDirtyAnswer = (to, navigate) => {
    dispatch(dirtyAnswerAction({ reset: !!to }));
    if (to) {
      navigate(to);
    }
  };

  return (
    <Dialog
      open={!!navigateTo}
      onClose={() => onDirtyAnswer()}
      noClear
      className={classes.root}
    >
      <DialogHeader>
        {t('Are you sure you want to leave this page?')}
      </DialogHeader>
      <DialogContent>
        <TextField variant="h5" color="secondary">
          {t('Your new changes will be lost.')}
        </TextField>
      </DialogContent>
      <DialogFooter>
        <Row spacing={2} align="center" justify="end">
          <FlatButton onClick={() => onDirtyAnswer()}>{t('Stay')}</FlatButton>
          <RaisedButton onClick={() => onDirtyAnswer(navigateTo, history.push)}>
            {t('Leave')}
          </RaisedButton>
        </Row>
      </DialogFooter>
    </Dialog>
  );
};

export default DirtyWarningDialog;
